/**
 *
 * useSchoolRole
 *
 */

import { pick } from 'lodash-es';
import { useApi2, useApi2call } from 'containers/Api2/index.js';
import { getIdNumber } from 'utils/userIdRole.js';
import { idValues } from 'utils/arrays.js';
import schoolRoleParser from './schoolRoleParser.js';

const SUBMIT_FIELDS = ['name', 'avatar', 'newAvatar', 'conversations'];

function removeFromState(state, member) {
  const uid = getIdNumber(member);
  const members = { ...state };
  members.list = members.list.filter((id) => id !== uid);
  delete members[uid];
  return members;
}

function addToState(state, action) {
  const newMembers = idValues(action.payload);
  const members = { ...state };
  members.list = members.list.slice(0); // create copy
  newMembers.forEach((member) => {
    const uid = getIdNumber(member);
    members.list.push(uid);
    members[uid] = member;
  });
  return members;
}

function useSchoolRole(schoolRoleId) {
  const url = `sa/schoolroles/${schoolRoleId}`;
  const schoolRole = useApi2({ url, version: 2, parser: schoolRoleParser, ignoreNoSignature: true });
  const api2call = useApi2call();

  function handleChange(key, val) {
    const body = pick({ ...schoolRole, [key]: val }, SUBMIT_FIELDS);
    api2call({ url, version: 2, method: 'PUT', body, parser: schoolRoleParser });
  }

  function addMembers(members) {
    const body = { members };
    api2call({ url: `${url}/members`, version: 2, method: 'POST', body, reducer: addToState });
  }

  async function deleteMember(member) {
    const { roleType, id } = member;
    await api2call({ url: `${url}/members/${roleType}/${id}`, selector: `${url}/members`, version: 2, method: 'DELETE', reducer: (state) => removeFromState(state, member) });
  }

  function changeConversations(val) {
    const body = { inbox: val };
    api2call({ url: `${url}/conversations`, version: 2, method: 'PUT', body });
  }

  return { schoolRole, handleChange, addMembers, deleteMember, changeConversations };
}

export default useSchoolRole;
